/* ==========================================================================
   IDUN · v2 pages — combined interactions
   Shared across page.sobre-nosotros, page.faq, page.contacto
   Every feature is guarded by element presence, so the file is safe to load
   on any of the three pages.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- HERO SOCK 3D — mouse parallax (Sobre nosotros) ---------- */
  (function heroParallax() {
    var stage = document.getElementById('heroStage');
    var sock = document.getElementById('sock3d');
    if (!stage || !sock) return;
    var rx = 0, ry = 0, tx = 0, ty = 0;
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      tx = py * -22;
      ty = px * 28;
    });
    stage.addEventListener('mouseleave', function () { tx = 0; ty = 0; });
    function tick() {
      rx += (tx - rx) * 0.08;
      ry += (ty - ry) * 0.08;
      sock.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
      requestAnimationFrame(tick);
    }
    tick();
    // gentle idle wobble
    var t = 0;
    setInterval(function () {
      t += 0.02;
      if (Math.abs(tx) < 0.5 && Math.abs(ty) < 0.5) {
        tx = Math.sin(t) * 4;
        ty = Math.cos(t * 0.7) * 6;
      }
    }, 40);
  })();

  /* ---------- FOUNDER FLIP CARDS (Sobre nosotros) ---------- */
  document.querySelectorAll('[data-flip]').forEach(function (card) {
    card.addEventListener('click', function () { card.classList.toggle('is-flipped'); });
  });

  /* ---------- VALUE CARDS — tilt + spotlight (Sobre nosotros) ---------- */
  document.querySelectorAll('[data-tilt]').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      var rx = (py - 0.5) * -10;
      var ry = (px - 0.5) * 10;
      card.style.transform = 'translateY(-6px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
      card.style.setProperty('--mx', (px * 100) + '%');
      card.style.setProperty('--my', (py * 100) + '%');
    });
    card.addEventListener('mouseleave', function () { card.style.transform = ''; });
  });

  /* ---------- SCROLL REVEAL (all pages) ---------- */
  (function scrollReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- IMPACT STAT — parallax disc on scroll (Sobre nosotros) ---------- */
  (function impactParallax() {
    var stat = document.getElementById('impactStat');
    if (!stat) return;
    var disc = stat.querySelector('.impact__stat-disc');
    if (!disc) return;
    window.addEventListener('scroll', function () {
      var r = stat.getBoundingClientRect();
      var center = window.innerHeight / 2;
      var offset = (r.top + r.height / 2 - center) / window.innerHeight;
      disc.style.transform = 'rotateY(' + (offset * -20) + 'deg) rotateX(' + (offset * 12) + 'deg)';
    }, { passive: true });
  })();

  /* ---------- HEADER glass shrink on scroll (all pages) ---------- */
  (function headerShrink() {
    var header = document.querySelector('.site-header__inner');
    if (!header) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        header.style.boxShadow = '0 14px 40px -12px rgba(107,31,42,0.18), inset 0 1px 0 rgba(255,255,255,0.8)';
      } else {
        header.style.boxShadow = '';
      }
    }, { passive: true });
  })();

  /* ---------- ACCORDION — close siblings within a category (FAQ) ---------- */
  (function accordions() {
    document.querySelectorAll('.faq-cat__list').forEach(function (list) {
      var items = list.querySelectorAll('.acc');
      items.forEach(function (acc) {
        acc.addEventListener('toggle', function () {
          if (acc.open) {
            items.forEach(function (other) { if (other !== acc) other.open = false; });
          }
        });
      });
    });
  })();

  /* ---------- PILL NAV — scrollspy (FAQ) ---------- */
  (function scrollSpy() {
    var links = Array.prototype.slice.call(document.querySelectorAll('.faq-pillnav a'));
    if (!links.length) return;
    var map = new Map();
    links.forEach(function (a) {
      var sec = document.querySelector(a.getAttribute('href'));
      if (sec) map.set(sec, a);
    });
    if (!map.size) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          var a = map.get(e.target);
          if (a) a.classList.add('is-active');
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    map.forEach(function (a, sec) { io.observe(sec); });
  })();

  /* ---------- MOBILE MENU — close on nav click (all pages) ---------- */
  (function mobileMenu() {
    var nav = document.getElementById('primary-nav');
    if (!nav) return;
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('is-open'); });
    });
  })();
})();
